import React, { useEffect } from "react";
import BlogComponent from "../components/Blog/BlogComponent";
import ScrollToTopButton from "./ScrollToTopButton";

const BlogPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="mt-header">
        <BlogComponent />
      </div>
      <ScrollToTopButton />
    </>
  );
};

export default BlogPage;
